// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3BLXb";
var _3 = "title-1fOWT";
export { _1 as "__esModule", _2 as "root", _3 as "title" }
export default { "__esModule": _1, "root": _2, "title": _3 }
